// removed by extract-text-webpack-plugin
module.exports = {"zoom-control":"magazines_3eNXE","hr":"magazines__EBga"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/ZoomControl/styles.scss
// module id = 1062
// module chunks = 1